import React from 'react';
import { MessageCircle } from 'lucide-react';
export function ObjectionsSection() {
  const faqs = [{
    q: 'Ya probé muchas cosas y ninguna funcionó.',
    a: 'Lo que probaste no estaba diseñado para el metabolismo nocturno de la mujer de más de 35. Este sí. La diferencia no está en tu cuerpo. Está en el método.'
  }, {
    q: 'No tengo tiempo para cocinar.',
    a: '15 minutos. Eso es menos que el tiempo que tardas en decidir qué pedir por delivery. Las recetas están diseñadas para la mujer más ocupada del mundo.'
  }, {
    q: 'Los ingredientes serán caros o difíciles de encontrar.',
    a: 'Todos los ingredientes de este protocolo se encuentran en cualquier mercado local de Latinoamérica o España. No necesitas tiendas especializadas ni importaciones.'
  }, {
    q: '¿Y si no me funciona a mí?',
    a: 'Para eso existe la garantía de 30 días. Prueba durante una semana completa. Si no funciona, pides el reembolso. Sin riesgo.'
  }, {
    q: 'Solo son $26.499 ARS, ¿qué tan bueno puede ser?',
    a: 'El precio no determina el valor. Este protocolo se basa en los mismos principios de cronobiología nutricional que aplican dietistas que cobran $377.212 ARS por consulta. La diferencia es que aquí lo tienes todo de una vez, a tu ritmo y por menos del precio de una cena fuera.'
  }, {
    q: '¿Es para mí aunque no tenga muchos kilos de más?',
    a: 'La inflamación no es solo peso. Es energía, es sueño, es calidad de vida. Este protocolo mejora todos esos aspectos independientemente de tu peso actual.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-208" data-mp="t1664ot4di5">
      <div className="max-w-3xl mx-auto" data-id="element-209" data-mp="ulzxs3arsey">
        <div className="text-center mb-12" data-id="element-210" data-mp="3s6dvpn5lj7lm">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-211" data-mp="3s5c86j7e8sn0">
            Sé Lo Que Estás Pensando
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-212" data-mp="2zjb1v8bv7l1p"></div>
        </div>

        <div className="space-y-6" data-id="element-213" data-mp="13fwhpxcbsjia">
          {faqs.map((faq, index) => <div key={index} className="bg-cream p-6 rounded-2xl border border-forest/5 shadow-sm" data-id="element-214" data-mp="13dim9ndqh5a7" data-mpi={index}>
              <div className="flex gap-4 items-start mb-3" data-id="element-215" data-mp="1d569fc39c05v">
                <MessageCircle className="text-gold shrink-0 mt-1" size={24} data-id="element-216" data-mp="1d7sijg5sqnq7" />
                <h3 className="text-lg md:text-xl font-bold text-dark italic" data-id="element-217" data-mp="1i3pw5epodfza">
                  "{faq.q}"
                </h3>
              </div>
              <p className="text-dark/80 pl-10 leading-relaxed" data-id="element-218" data-mp="pfbxqxuochn7">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}